__turbopack_context__.v({
  "feature": "TravelChargerModal-module__F6rz_a__feature",
  "features": "TravelChargerModal-module__F6rz_a__features",
  "featuresGroup": "TravelChargerModal-module__F6rz_a__featuresGroup",
  "imgWrapper": "TravelChargerModal-module__F6rz_a__imgWrapper",
  "pricingModal": "TravelChargerModal-module__F6rz_a__pricingModal",
});
